import { DocumentListItemProps } from "../../Components/DocumentListItem";

export const policyDocuments: DocumentListItemProps[] =
    [
        {
            title: 'Health & Safety Policy',
            downloadLink: '/docs/Health and Safety Policy Rev 3 (November 2022).pdf'
        },
        {
            title: 'Environmental Policy',
            downloadLink: '/docs/Environmental Policy Rev 1 (April 2022).pdf'
        },
        {
            title: 'Quality Policy',
            downloadLink: '/docs/Quality Policy Rev 3 (April 2022).pdf'
        },
        {
            title: 'Gifts & Entertainment Policy',
            downloadLink: '/docs/Gifts & Entertainment Policy Iss 1.pdf'
        }
    ];

export const guidanceDocuments: DocumentListItemProps[] =
    [
        {
            title: 'Environmental Guidance for Visitors & Contractors',
            downloadLink: '/docs/DS0010 Iss 1 - Environmental Guidance for Visitors and Contractors.pdf'
        },
        {
            title: 'Health & Safety Guidance for Visitors & Contractors',
            downloadLink: '/docs/HSE0006 Iss 1 - Health & Safety Guidance for Visitors and Contractors.pdf'
        }
    ];

export const certificationDocuments: DocumentListItemProps[] =
    [
        {
            title: 'AS9100 Certificate (Q 09065)',
            downloadLink: '/docs/Q 09065 Rev D (11.05.2029).pdf'
        },
        {
            title: 'ISO 45001 Certificate (OHS 712756)',
            downloadLink: '/docs/OHS 712756 (24.11.2026).pdf'
        },
        {
            title: 'ISO 14001 Certificate (EMS 740749)',
            downloadLink: '/docs/EMS 740749 (04.07.2028).pdf'
        }
    ];

export const termsAndConditionsDocuments: DocumentListItemProps[] =
    [
        {
            title: 'Terms & Conditions of Purchase',
            downloadLink: '/docs/Terms and Conditions of Purchase (Jan 2024).pdf'
        },
        {
            title: 'Terms & Conditions of Sale',
            downloadLink: '/docs/Terms and Conditions of Sale (April 2022).pdf'
        }
    ];
